import { signOut } from 'firebase/auth';
import React from 'react';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import { useAuthState } from 'react-firebase-hooks/auth';
import { NavLink, useNavigate } from 'react-router-dom';
import auth from '../../firebase';
import userImage from '../../image/userImg.png';
import Loading from '../Loading/Loading';
import './Header.css';
const Header = () => {
    const navigate = useNavigate();
    const [user, loading] = useAuthState(auth);

    if(loading){
        return <Loading/>
    }
    
    return (
        <header>
            <Navbar bg='dark' fixed='top' expand="lg" variant='dark' className='py-4'>
                <Container>
                    <Navbar.Brand href="/home">
                        <b>Trainer Micheal</b>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mx-auto">
                        <NavLink className='nav-link' to="/home">Home</NavLink>
                        <NavLink className='nav-link' to="/about">About Me</NavLink>
                        <NavLink className='nav-link' to="/blogs">Blogs</NavLink>
                    </Nav>
                        <Nav>
                           { user ? 
                           <>
                                <img src={user?.photoURL ? user?.photoURL: userImage } width='100px' alt="" />
                                <Button onClick={()=>signOut(auth)}>Login Out</Button>
                           </>
                           :<Button onClick={()=>navigate('/login')}>Login</Button>}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default Header;